import { IDynamicDiplayView } from '@components/widgets/dynamic-display';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';

import { GetPolicyDetails } from '../types';

export function buildPolicyDetailsView(
  data: GetPolicyDetails
): IDynamicDiplayView {
  return {
    name: 'PolicyDetails',
    sections: [
      {
        name: 'PolicyDetails',
        title: 'Policy Details',
        properties: {
          PolicyIssueDate: {
            name: 'PolicyIssueDate',
            title: 'Policy Issue Date',
            value: data?.policyIssueDate || '',
            type: EnhancedDisplayType.Date,
            multiline: false,
            tooltip: false
           },
          PolicyEffectiveDate: {
            name: 'PolicyEffectiveDate',
            title: 'Policy Effective Date',
            value: data?.policyEffectiveDate || '',
            type: EnhancedDisplayType.Date,
            multiline: false,
            tooltip: false
          },
          PolicyEndDate: {
            name: 'PolicyEndDate',
            title: 'Policy End Date',
            value: data?.policyExpiryDate || '',
            type: EnhancedDisplayType.Date,
            multiline: false,
            tooltip: false
          },
          PolicyCurrency: {
            name: 'PolicyCurrency',
            title: 'Policy Currency',
            value: data?.policyCurrency?.title || '',
            multiline: false,
            tooltip: false,
          }
        }
      },
      {
        name: 'RenewalDetails',
        title: 'Renewal Details',

        properties: {
          Renewal: {
            name: 'Renewal',
            title: 'Renewal',
            value: data?.isRenewal ? 'Yes' : 'No',
            multiline: true,
            tooltip: false,
            breaksRow: false
          },
          RenewalFrom: {
            name: 'RenewalFrom',
            title: 'Renewal From',
            value:data?.renewalFrom?.policyNumber,
            type: EnhancedDisplayType.RelativeLink,
            url: `/production/policies/${data?.renewalFromID}`,
            multiline: true,
            tooltip: false,
            breaksRow: true
          },
          Renewed: {
            name: 'Renewed',
            title: 'Renewed',
            value: data?.isRenewed ? 'Yes' : 'No',
            multiline: true,
            tooltip: false
          },
          RenewedTo: {
            name: 'RenewedTo',
            title: 'Renewed To',
            value: data?.renewalTo?.policyNumber,
            type: EnhancedDisplayType.RelativeLink,
            url: `/production/policies/${data?.renewalToID}`,
            multiline: true,
            tooltip: false
          }
        }
      }
    ]
  };
}
